// extracted by mini-css-extract-plugin
module.exports = {"box":"box___3Dd2R","banner":"banner___1pChE","pagination":"pagination___1bUxV"};